import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms'

@Component({
  selector: 'app-add-liability',
  templateUrl: './add-liability.component.html',
  styleUrls: ['./add-liability.component.scss']
})
export class AddLiabilityComponent implements OnInit {
	@Input() qID: any = null;
	@Input() public index: number;
	@Input() public liability: FormGroup;
	@Output() public removed: EventEmitter<number> = new EventEmitter<number>();
	@Input() public displayErrors: boolean;
	@Input() public displayX: boolean;

	types: string[] = ["הלוואה (מכל סוג)", "מזונות","משכנתא", "שכר דירה", "אחר"];
	defaultValue = "";
	
  constructor() { }

  ngOnInit() {
  }
  udateValue(){
	  if(this.liability.get('liabilityType').value=='מזונות' ||this.liability.get('liabilityType').value=='שכר דירה')
	this.liability.get('liabilityBalance').setValue(0);  
  }
  static buildLiability(val: any) {
	//value equal to val if val exist else equal to "", disabled equal to true if val exist and equal to mezonot or Rent else equal to false 
    let fg:FormGroup =  new FormGroup({
		liabilityType: new FormControl(val? val[0].answerValue : ""),
		liabilityBalance: new FormControl(val? val[1].answerValue : ""),
		liabilityMonthlyRefund: new FormControl(val? val[2].answerValue : ""),
		required: new FormControl(val? val.required : false)
	});
	return fg;
  }
}



// WEBPACK FOOTER //
// ./src/app/add-liability/add-liability.component.ts